import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = {
  class: "notification-panel__scroll"
};
const _hoisted_3 = {
  key: 0,
  class: "notification-panel__empty"
};
const _hoisted_4 = {
  key: 1,
  class: "notification-panel__list"
};
const _hoisted_5 = ["onClick", "onKeydown"];
const _hoisted_6 = {
  key: 1,
  class: "notification-panel__icon-follow"
};
const _hoisted_7 = {
  key: 3,
  class: "notification-panel__icon-at",
  "aria-hidden": "true"
};
const _hoisted_8 = {
  class: "notification-panel__content"
};
const _hoisted_9 = {
  class: "notification-panel__title-row"
};
const _hoisted_10 = {
  class: "notification-panel__item-title"
};
const _hoisted_11 = {
  key: 0,
  class: "notification-panel__dot",
  "aria-hidden": "true"
};
const _hoisted_12 = {
  class: "notification-panel__desc"
};
const _hoisted_13 = ["datetime"];
const _hoisted_14 = {
  key: 2,
  class: "notification-panel__empty"
};
const _hoisted_15 = {
  class: "notification-panel__footer"
};
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { Bell, UserFilled, Plus, ChatDotRound } from '@element-plus/icons-vue';
import AppImage from '@/components/common/AppImage.vue';
import { getNotificationPage, markNotificationRead } from '@/api/social';
import { normalizeNotificationPage, mapNotificationRow, panelIconClass, buildNotificationNavigateTarget } from '@/utils/notification-map';
import { applyMarketOpenMetaFromLocation } from '@/utils/analytics-market-open';
import { trackAnalyticsLog } from '@/utils/analytics-track';
const NOTIFICATION_CACHE_PREFIX = 'vantag_notification_';

/** 本会话已点过的 id，避免关窗重开时接口延迟仍把未读写回来 */

export default {
  __name: 'NotificationPanel',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'read'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const router = useRouter();
    const {
      locale
    } = useI18n();
    const rows = ref([]);
    const loading = ref(false);
    const locallyReadIds = new Set();
    watch(() => props.modelValue, open => {
      if (open) loadUnreadList();
    });
    function resolveRowId(item) {
      return String(item?.id ?? item?.raw?.id ?? item?.raw?.notificationId ?? '').trim();
    }
    async function loadUnreadList() {
      loading.value = true;
      try {
        const data = await getNotificationPage({
          pageNum: 1,
          pageSize: 20
        });
        rows.value = normalizeNotificationPage(data).map(row => mapNotificationRow(row, locale.value)).filter(item => item.unread && !locallyReadIds.has(resolveRowId(item))).slice(0, 5);
      } catch (err) {
        console.warn('[NotificationPanel] load failed', err);
        rows.value = [];
      } finally {
        loading.value = false;
      }
    }
    function cacheNotification(item) {
      try {
        sessionStorage.setItem(`${NOTIFICATION_CACHE_PREFIX}${item.id}`, JSON.stringify(item.raw));
      } catch {
        /* ignore quota errors */
      }
    }
    function markRowReadLocally(item) {
      if (!item?.unread) return;
      item.unread = false;
      const nid = resolveRowId(item);
      if (nid) locallyReadIds.add(nid);
      rows.value = rows.value.filter(row => row.unread);
      emit('read');
    }
    async function onRowClick(item) {
      trackAnalyticsLog({
        key: 'notification.click',
        label: '点击通知',
        value: {
          id: item?.id != null ? String(item.id) : undefined,
          source: 'panel'
        }
      });
      markRowReadLocally(item);
      const nid = resolveRowId(item);
      if (nid) {
        markNotificationRead(nid).catch(err => {
          console.warn('[NotificationPanel] mark read failed', err);
        });
      } else {
        console.warn('[NotificationPanel] missing notification id', item?.raw);
      }
      cacheNotification(item);
      const to = buildNotificationNavigateTarget(item);
      if (!to) {
        return;
      }
      emit('update:modelValue', false);
      if (typeof to === 'string' && /^https?:\/\//i.test(to)) {
        window.location.href = to;
        return;
      }
      applyMarketOpenMetaFromLocation(to, 'notification');
      router.push(to);
    }
    function onViewAll() {
      emit('update:modelValue', false);
      router.push({
        name: 'NotificationsCenter',
        query: {
          tab: 'general'
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createBlock(_Transition, {
        name: "notify-panel"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", {
          class: "notification-panel",
          role: "dialog",
          "aria-label": _ctx.$t('nav.notifications'),
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          onPointerdown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [_createElementVNode("div", _hoisted_2, [loading.value ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('notifications.loading')), 1)) : rows.value.length ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, row => {
          return _openBlock(), _createElementBlock("li", {
            key: row.id,
            class: _normalizeClass(["notification-panel__item", {
              'is-unread': row.unread
            }]),
            role: "button",
            tabindex: "0",
            onClick: _withModifiers($event => onRowClick(row), ["stop"]),
            onKeydown: [_withKeys(_withModifiers($event => onRowClick(row), ["prevent"]), ["enter"]), _withKeys(_withModifiers($event => onRowClick(row), ["prevent"]), ["space"])]
          }, [_createElementVNode("div", {
            class: _normalizeClass(["notification-panel__icon", `notification-panel__icon--${_unref(panelIconClass)(row.iconType)}`])
          }, [row.senderAvatar ? (_openBlock(), _createBlock(AppImage, {
            key: 0,
            src: row.senderAvatar,
            alt: "",
            class: "notification-panel__avatar-img"
          }, null, 8, ["src"])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [row.iconType === 'bell' ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            class: "notification-panel__el-icon",
            size: 20
          }, {
            default: _withCtx(() => [_createVNode(_unref(Bell))]),
            _: 1
          })) : row.iconType === 'follow' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_icon, {
            class: "notification-panel__el-icon",
            size: 18
          }, {
            default: _withCtx(() => [_createVNode(_unref(UserFilled))]),
            _: 1
          }), _createVNode(_component_el_icon, {
            class: "notification-panel__icon-follow-plus",
            size: 14
          }, {
            default: _withCtx(() => [_createVNode(_unref(Plus))]),
            _: 1
          })])) : row.iconType === 'chat' ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 2,
            class: "notification-panel__el-icon",
            size: 20
          }, {
            default: _withCtx(() => [_createVNode(_unref(ChatDotRound))]),
            _: 1
          })) : (_openBlock(), _createElementBlock("span", _hoisted_7, "@"))], 64))], 2), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(row.title), 1), row.unread ? (_openBlock(), _createElementBlock("span", _hoisted_11)) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_12, _toDisplayString(row.content), 1), _createElementVNode("time", {
            class: "notification-panel__time",
            datetime: row.timeIso
          }, _toDisplayString(row.timeLabel), 9, _hoisted_13)])], 42, _hoisted_5);
        }), 128))])) : (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('notifications.empty')), 1))]), _createElementVNode("div", _hoisted_15, [_createElementVNode("button", {
          type: "button",
          class: "notification-panel__footer-btn",
          onClick: onViewAll
        }, _toDisplayString(_ctx.$t('notifications.footerViewAll')), 1)])], 40, _hoisted_1), [[_vShow, __props.modelValue]])]),
        _: 1
      });
    };
  }
};